import { Link, NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X, Instagram } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/portfolio", label: "Projects" },
  { to: "/services", label: "Services" },
  { to: "/process", label: "Process" },
  { to: "/about", label: "About" },
  { to: "/blog", label: "Journal" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${scrolled ? "bg-[#F9F8F6]/95 backdrop-blur-md border-b border-[#D5D0C8] shadow-sm" : "bg-[#F9F8F6]/85 backdrop-blur-sm"}`}
    >
      <div className="container-editorial flex items-center justify-between h-20 md:h-24">
        <Link to="/" data-testid="site-logo" className="flex items-center gap-3">
          <img src="/brand/hiraya-logo.png" alt="Hiraya" className="h-11 md:h-14 w-auto" />
        </Link>
        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-[15px] font-medium tracking-wide transition-colors ${isActive ? "text-[#A85C42]" : "text-[#1A1918] hover:text-[#A85C42]"}`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-4">
          <a href="https://www.instagram.com/thehiraya_" target="_blank" rel="noreferrer" data-testid="header-instagram" className="text-[#1A1918] hover:text-[#A85C42] transition">
            <Instagram size={20} strokeWidth={1.5} />
          </a>
          <Link
            to="/consultation"
            data-testid="header-cta-book"
            className="px-6 py-3 bg-[#1A1918] text-[#F9F8F6] text-[11px] font-medium uppercase tracking-[0.22em] hover:bg-[#A85C42] transition-colors rounded-sm"
          >
            Book a Consultation
          </Link>
        </div>
        <button
          className="lg:hidden p-2 text-[#1A1918]"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          aria-label="menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden bg-[#F9F8F6] border-t border-[#D5D0C8]">
          <div className="container-editorial py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                className={({ isActive }) => `text-lg font-medium ${isActive ? "text-[#A85C42]" : "text-[#1A1918]"}`}
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/consultation"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-book"
              className="mt-2 px-5 py-3 bg-[#1A1918] text-[#F9F8F6] text-xs uppercase tracking-[0.22em] text-center rounded-sm"
            >
              Book a Consultation
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
